<template>
  <div class="pageContent driving">
    <LoadingModal />
    <div v-if="!$store.state.pageLoading">
      <Top :title="name" :message="tips" v-if="tips != ''" />
      <VTitle val="请选择面值" :showLine="false" />
      <TypeList
        :status="radio"
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :isMember="isMember"
        :canSel="canSel"
        :vip_discount="vip_discount"
      />
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        ref="payway"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        @onComfirm="payHandle"
      />
      <Tips :content="describe">
        <div slot="content">
          <ul
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <span>代驾服务由“E代驾”提供。</span>
            </li>
            <li style="list-style: disc">
              <span
                >一次只支持使用一张代驾券；代驾券不拆分、不找零，不叠加。</span
              >
            </li>
            <li style="list-style: disc">
              <span
                >代驾券不支持退款，不支持转让，不支持折算剩余次数退款。</span
              >
            </li>
          </ul>
        </div>
      </Tips>
    </div>
  </div>
</template>

<script>
import { getProductList, getDrivingCodeUrl } from "api/onLine";
import { couponExchange } from "api/offLine";

export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    ident: String,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      radio: 0,
      area: "",
      // 数据列表
      selList: [],
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      params: { productId: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
    };
  },
  created() {
    this.$store.commit("setPageLoading", false);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    resetData() {
      this.selList = this.selListDefaultData.list;
      this.canSel = false;
      this.selItem = null;
      this.sellData = { sell_price: -1 };
    },
    loadData() {
      getProductList(this.ident, this.mouldId).then((res) => {
        this.$clear();
        if (res.status == 200) {
          if (typeof res.data == "object") {
            this.selList = res.data;
            this.canSel = true;
          }
        } else {
          this.resetData();
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
          this.$clear();
        });
      });
    },
    handleSel(i) {
      this.selItem = i;
      this.sellData = {
        ...this.selList[i],
        sell_price: Number(this.selList[i].productCustomerPrice),
      };
      this.params.productId = this.selList[i].productId;
    },
    payHandle(data) {
      this.$loading("支付中");
      let params = {
        productId: this.params.productId,
        couponIds: data.couponIds,
      };
      couponExchange(params).then((res) => {
        if (res.status == 200) {
          this.$successSync("购买成功", () => {
            this.getCodeUrl(res.data);
          });
        } else {
          this.$error(res.message);
        }
      });
    },
    getCodeUrl(tradeNo) {
      getDrivingCodeUrl(tradeNo).then((res) => {
        if (res.status == 200) {
          window.location.href(res.data.url);
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.driving {
}
</style>
